/**
 * Main-thread storage wipe for SQLite VFS (OPFS + idb-* IndexedDB).
 * Used after logout when the worker may have been killed mid-operation.
 */

import { debugWarn } from '../../utils/debug';

export const OPFS_SQLITE_DIRECTORY = 'sqlite-files';
export const DEFAULT_OFFLINE_DB_NAME = 'b2b_offline';

const IDB_VFS_DELETE_MAX_MS = 5_000;

export async function deleteOpfsSqliteDirectory(): Promise<void> {
  if (typeof navigator === 'undefined' || !navigator.storage?.getDirectory) {
    return;
  }
  try {
    const root = await navigator.storage.getDirectory();
    await root.removeEntry(OPFS_SQLITE_DIRECTORY, { recursive: true });
  } catch {
    // directory may not exist or OPFS unavailable
  }
}

export function deleteIdbVfsDatabase(dbName: string = DEFAULT_OFFLINE_DB_NAME): Promise<void> {
  return new Promise((resolve) => {
    const finish = (): void => {
      window.clearTimeout(hardStop);
      resolve();
    };
    const hardStop = window.setTimeout(finish, IDB_VFS_DELETE_MAX_MS);
    try {
      const req = indexedDB.deleteDatabase(`idb-${dbName}`);
      req.onsuccess = finish;
      req.onerror = () => {
        debugWarn('[storage-reset] idb VFS delete error:', req.error);
        finish();
      };
      req.onblocked = finish;
    } catch {
      finish();
    }
  });
}

export function deleteCriticalBackupIndexedDb(): Promise<void> {
  return new Promise((resolve) => {
    const finish = (): void => {
      window.clearTimeout(hardStop);
      resolve();
    };
    const hardStop = window.setTimeout(finish, 4_000);
    try {
      const req = indexedDB.deleteDatabase('b2b_offline_critical');
      req.onsuccess = finish;
      req.onerror = finish;
      req.onblocked = finish;
    } catch {
      finish();
    }
  });
}
